export const IMAGE_CONSTRAINTS = {
    MAX_SIZE_MB: 5,
    MAX_SIZE_BYTES: 5 * 1024 * 1024,
    ACCEPTED_TYPES: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
};
export const CAMERA_CONFIG = {
    IDEAL_WIDTH: 1920,
    IDEAL_HEIGHT: 1080,
    FACING_MODE: 'user',
    VIDEO_TIMEOUT_MS: 10000,
    JPEG_QUALITY: 0.92,
};
export const UI_CONSTANTS = {
    SUPPRESS_CLICK_DELAY_MS: 250
};
export const MESSAGE_KEYS = {
    CAMERA_ERROR: 'camera-error',
    PHOTO_UPLOAD: 'photo-upload',
};
export const MIME_TO_EXTENSION = {
    'image/png': 'png',
    'image/webp': 'webp',
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
};
export const AVATAR_SIZE = 120;
export const PHOTO_URL_REFRESH_BUFFER_MS = 30000;
export const PHOTO_URL_FALLBACK_EXPIRY_MIN = 10;
export const PHOTO_URL_EMPTY_CACHE_TTL_MS = 30000;
export const PHOTO_URL_CHECK_INTERVAL_MS = 60000;
